// @ts-nocheck
import { get } from 'lodash'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import theme from '../../../LEGACY/theme'
import DateField from './DateField'

export default function BirthdateField(props) {
  const { formKey, values, disabled } = props
  const value = get(values, formKey)

  // Note that dayjs will parse 0000 as the current year,
  // causing big problems in terms of comparison to a cut
  // off date as well as future dates.
  //
  // Additionally it will parse anything with more than one
  // leading zero as 19XX e.g. 0099 -> 1999 again letting us
  // accidentally bypass validaiton.
  //
  // So first, eliminate all cases which will be parsed wrong
  // due to leading zeros
  //
  let displayAge = 0

  const [_dd, _mm, yyyy] = value?.split('-') ?? []

  if (yyyy && yyyy.length === 4) {
    const year = parseInt(yyyy, 10)

    if (!Number.isNaN(year)) {
      const parsedBirthdate = dayjs(value, 'DD-MM-YYYY')

      if (parsedBirthdate.isValid()) {
        // force back to 00XX if parsed incorrectly via numeric year setter
        displayAge = dayjs().diff(parsedBirthdate.year(year), 'years')
      }
    }
  }

  return (
    <DateField {...props} disabled={disabled}>
      {value && (
        <div style={localStyles.ageWrapper} className="age-value">
          <div style={localStyles.ageText}>Age</div>
          <div
            style={{
              ...localStyles.ageValue,
              ...(disabled && localStyles.disabled)
            }}
          >
            {displayAge}
          </div>
        </div>
      )}
    </DateField>
  )
}

const localStyles = {
  ageWrapper: {
    display: 'flex',
    flex: 1,
    marginRight: 15
  },
  ageText: {
    paddingTop: 7
  },
  ageValue: {
    background: colors.grey,
    borderRadius: 5,
    fontWeight: 600,
    height: theme.input.height,
    marginLeft: 5,
    padding: '7px 10px 0px 10px'
  },
  disabled: {
    opacity: 0.39
  }
}
